/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_AlreadyInputs */

const en_confirm_already = /** @type {(inputs: Confirm_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This lesson has already been confirmed.`)
};

const he_confirm_already = /** @type {(inputs: Confirm_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השיעור הזה כבר אושר.`)
};

/**
* | output |
* | --- |
* | "This lesson has already been confirmed." |
*
* @param {Confirm_AlreadyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_already = /** @type {((inputs?: Confirm_AlreadyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_AlreadyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_already(inputs)
	return he_confirm_already(inputs)
});